import { createContext, useContext, type ReactNode } from "react";

/**
 * Exposes the value of the form tab currently rendering its children, so that
 * maskable fields can self-register under the right tab in the visibility grid.
 */
const CurrentTabContext = createContext<string | undefined>(undefined);

export function CurrentTabProvider({
  value,
  children,
}: {
  value: string | undefined;
  children: ReactNode;
}) {
  return (
    <CurrentTabContext.Provider value={value}>
      {children}
    </CurrentTabContext.Provider>
  );
}

/** The `value` of the enclosing form tab, or undefined when outside a tab. */
export function useCurrentTab(): string | undefined {
  return useContext(CurrentTabContext);
}
